import { ref } from "vue";

export const showAlertDisconnected = ref(false);